import { Text } from '@betterment/samba-react';

import { SambaAutoLink } from '~/b4b/components/SambaAutoLink';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

export const CashFund: React.FC = () => {
  return (
    <>
      <Text as="p" css={{ pb: 'space.200' }}>
        Cash funds arise from unexpected operational situations that result in excess funds in the 401(k) plan, such as
        duplicate payrolls, payroll corrections, compliance corrections, and other miscellaneous discrepancies. These
        funds are usually used to correct the applicable error or may be returned to the plan sponsor if they meet the
        IRS's "Mistake of Fact" criteria. Earnings on these amounts cannot be returned to the plan sponsor — they're
        typically characterized as suspense funds instead.
      </Text>

      <Text as="p" css={{ pb: 'space.200' }}>
        You can view when and why cash funds were generated by running a{' '}
        <SambaAutoLink to={urlBuilder.reportsNew({ report: 'cash_account' })}>Cash Fund Report</SambaAutoLink>. To learn
        more, visit our{' '}
        <SambaAutoLink target="_blank" rel="noopener noreferrer" to={urlBuilder.getUnallocatedFundsGuide()}>
          Guide to Unallocated Funds
        </SambaAutoLink>
        .
      </Text>

      <Text as="p" css={{ pb: 'space.200' }}>
        If your plan's{' '}
        <SambaAutoLink to={urlBuilder.unallocatedFundsAutomationEdit()}>Auto-apply unallocated funds</SambaAutoLink>{' '}
        setting is on, we'll automatically apply these funds to employer 401(k) match when they are available.
      </Text>
    </>
  );
};
